
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '0523SHLJ';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '竞赛答题',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '相关新闻',
      path: `/${baseUrl}/news`,
      id: 2,
    },
    {
      title: '活动规则',
      path: `/${baseUrl}/rule`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '分享主标题',
      url: location.href,
      subtitle: `分享副标题`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '分享主标题',
        subtitle: `分享副标题`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
